import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Checkbox from '../checkbox';

const dummyData = [{ id: 111, label: 'nischal1nischal1nischal1nischal1nischal1nischal1nischal1nischal1nischal1nischal1nischal1nischal1nischal1nischal1nischal1nischal1nischal1nischal1nischal1nischal1nischal1nischal1nischal1' }, { id: 222, label: 'nischal2' }, { id: 333, label: 'nischal3' }, { id: 444, label: 'nischal3' }, { id: 555, label: 'nischal3' }, { id: 666, label: 'nischal3' }, { id: 777, label: 'nischal3' }, { id: 333, label: 'nischal3' }, { id: 888, label: 'nischal3' }, { id: 999, label: 'nischal3' }, { id: 101, label: 'nischal3' }, { id: 102, label: 'nischal3' }, { id: 103, label: 'nischal3' }, { id: 104, label: 'nischal3' }, { id: 105, label: 'nischal3' }, { id: 106, label: 'nischal3' }, { id: 107, label: 'nischal3' }]

const CheckboxGroup = ({ options = dummyData, value, defaultValue, enableSelectAll = false, selectAllLabel = "Select All", alignment = "column", onChange }) => {

    // states
    const [selectedIds, setSelectedIds] = useState([])

    // useRef
    const isMounted = useRef(false);

    //useMemo
    // Note: have kept in useMemo because this const will update if options gets updated
    const allOptionsIds = useMemo(() => {
        return options.map((option, optionIndex) => option?.id || `checkbox-${optionIndex}`)
    }, [options])

    useEffect(() => {
        if (value) {
            setSelectedIds(value)
        }
    }, [value])

    useEffect(() => {
        if (!isMounted.current) {
            isMounted.current = true;
            if (defaultValue) {
                setSelectedIds(defaultValue)
            }
        }
    }, [defaultValue])


    const onChangeCheckbox = useCallback((changedState, changedData) => {
        const changedId = changedData.id
        if (!value) {
            // checking if that id already exists then removing else adding it
            const updatedData = selectedIds.includes(changedId) ? selectedIds.filter(prevSelectedId => prevSelectedId !== changedId) : [...selectedIds, changedId]
            setSelectedIds(updatedData)
            onChange && onChange(changedState, updatedData)
        }
    }, [value, selectedIds, onChange])

    const onChangeSelectAll = useCallback((changedState) => {
        // if selecting then updating the state with all ids else upating it with empty data
        const updatedData = changedState ? allOptionsIds : []
        setSelectedIds(updatedData)
        onChange && onChange(changedState, updatedData)
    }, [allOptionsIds, onChange])


    return (
        <div className='checkboxGroup'>
            {enableSelectAll && <Checkbox label={selectAllLabel} value={allOptionsIds.length === selectedIds.length} onChange={onChangeSelectAll} />}
            <hr className='checkboxGroup-seperator' />
            <div className={`checkboxGroup-children checkboxGroup-children-${alignment}`}>
                {options.map(checkboxData => <Checkbox value={selectedIds.includes(checkboxData.id)} onChange={onChangeCheckbox} key={checkboxData.id} id={checkboxData.id} label={checkboxData?.label || checkboxData?.name || 'Checkbox'}>{checkboxData?.render}</Checkbox>)}
            </div>
        </div>
    );
}

export default CheckboxGroup;